import { ReducersMapObject } from 'redux';

import * as Item from '@common/react/store/Item';
import { BaseAppThunkAction, baseReducers } from '@common/react/store';
import { ApplicationStateWithChats, getReducer as getChatsReducer } from '@common/react/components/Chat/Store/Chats';
import { ServerPageState, reducer as PageStateReducer } from '@common/react/store/ServerPage';
import { VideoChatState, getReducer as getVideoChatReducer } from '@common/react/store/VideoChat';
import { ItemsState as ItemsProviderStoreState, getReducer as getIPStoreReducer } from '@common/react/store/ItemsProviderStore';
import { getReducer, ItemState } from '@common/react/store/ItemProviderStore';

import { BaseInvite } from '@commonTuna/react/objects/BaseInvite';

import { User } from '@app/objects/User';
import { HeaderState, reducer as HeaderReducer } from '@app/store/HeaderSearch';
import { CountersState, reducer as CountersReducer } from '@app/store/Counters';
import { SearchFilterState, reducer as SearchFilterReducer } from '@app/store/SearchFilter';
import { UserRegistrationSteps } from '@app/components/Pages/Register/PatientMainForm';
import { BuildData } from '@app/objects/BuildData';
import { SecureRoutesPropsPagesMap } from '@app/objects/SecureRoutesPropsPagesMap';
import { HostOptions } from '@app/objects/HostOptions';

// The top-level state object
export interface ApplicationState extends ApplicationStateWithChats<User> {
	serverPage: ServerPageState<any>;

	routesPropsPagesMap: ItemState<SecureRoutesPropsPagesMap>;
	buildData: ItemState<BuildData>;
	hostOptions: ItemState<HostOptions>;

	companyTemplateInvites: ItemsProviderStoreState<BaseInvite>;

	userRegistrationSteps: Item.ItemState<UserRegistrationSteps>;

	counters: CountersState;

	header: HeaderState;

	searchFilterData: SearchFilterState;

	videoChat: VideoChatState;
}

// Whenever an action is dispatched, Redux will update each top-level application state property using
// the reducer with the matching name. It's important that the names match exactly, and that the reducer
// acts on the corresponding ApplicationState property type.
export const reducers: ReducersMapObject = {
	...baseReducers,

	serverPage: PageStateReducer<any>('serverPage'),

	routesPropsPagesMap: getReducer<SecureRoutesPropsPagesMap>('routesPropsPagesMap'),
	buildData: getReducer<BuildData>('buildData'),
	hostOptions: getReducer<HostOptions>('hostOptions'),

	chats: getChatsReducer(),

	companyTemplateInvites: getIPStoreReducer<BaseInvite>('companyTemplateInvites'),

	userRegistrationSteps: Item.getReducer<UserRegistrationSteps>('userRegistrationSteps'),

	counters: CountersReducer,

	header: HeaderReducer,

	searchFilterData: SearchFilterReducer,

	videoChat: getVideoChatReducer(),
};

// This type can be used as a hint on action creators so that its 'dispatch' and 'getState' params are
// correctly typed to match your store.
export type AppThunkAction<TAction> = BaseAppThunkAction<TAction, User, ApplicationState>
